import { patch } from '../../../helpers/fetch';

import { buildURL, urls } from '../../../helpers/urls';

// eslint-disable-next-line import/prefer-default-export
export const updateSeatType = (event) => {
  const url = buildURL(urls.events.root, 'seatOptions');
  return patch(url, event);
};
